export function notNull<T>(value: T | null | undefined): T {
    if (value === null || value === undefined) {
        // report error via ErrorReportController::api_frontend_js_error
        throw new Error('Value cannot be null or undefined');
    }
    return value;
}

